import React, { useState } from "react";
import hola from "./assets/exhibit1.png";
import holl from "./assets/exhibit2.png";
import teb from "./assets/exhibit3.png";
import pra from "./assets/exhibit4.png";
import contact from "./assets/contact.png";
import house from "./assets/house-market.png";
import { toast } from "react-toastify";
import { Animated } from "react-animated-css";

function Home() {
  const [mailerState, setMailerState] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  function handleStateChange(e) {
    setMailerState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // console.log({ mailerState });
    const url = "http://localhost:5000/send";
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({ mailerState }),
    })
      .then((res) => res.json())
      .then(async (res) => {
        const resData = await res;

        if (resData.status === "success") {
          setLoading(false);
          toast.success("Message Sent");
        } else if (resData.status === "fail") {
          setLoading(false);
          toast.error("Message failed to send");
        }
      })
      .then(() => {
        setMailerState({
          email: "",
          name: "",
          message: "",
        });
      });
  };

  return (
    <>
      <div className="dark:bg-black font-mono relative overflow-hidden transition-opacity ">
        <section>
          <div className="relative pt-[120px] lg:pt-[150px] pb-[110px]  dark:text-white">
            <div className="container">
              <Animated
                animationIn="slideInUp"
                animationOut="fadeOut"
                isVisible={true}
              >
                <h1
                  className="
                  text-dark
                  font-extrabold
                  text-8xl
                  lg:text-[140px]
                  xl:text-[142px]
                  leading-snug
                  text-center
                "
                  style={{ fontFamily: "sans-serif" }}
                >
                  HELLO
                </h1>
              </Animated>
              <div className="flex flex-wrap  lg:-ml-24 -my-24">
                <div className="hidden lg:block lg:w-1/12 px-4" />

                <div className="w-full lg:w-6/12 ">
                  <div className="lg:text-right lg:ml-auto -mt-32">
                    <div className="relative inline-block z-10 pt-11 lg:pt-0">
                      <Animated
                        animationIn="bounceInLeft"
                        animationOut="fadeOut"
                        isVisible={true}
                        animationInDelay={500}
                      >
                        <img
                          src={hola}
                          alt="hero"
                          className="max-w-full lg:ml-auto"
                        />
                      </Animated>
                    </div>
                  </div>
                </div>

                <div className="w-full lg:w-4/12 px-4 container">
                  <div className="hero-content">
                    <Animated
                      animationIn="bounceInRight"
                      animationOut="fadeOut"
                      isVisible={true}
                      animationInDelay={700}
                    >
                      <p className="  font-normal text-lg  dark:text-white text-gray-800  text-justify   lg:mt-24  leading-loose ">
                        My name is Kehinde, a software engineer based in
                        Toronto, Canada with a primary focus on modern frontend
                        technologies and a passion for writing functional and
                        clean code.
                      </p>
                    </Animated>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" mt-14 ">
          <div className="container mx-auto px-2 flex flex-col justify-between items-center relative py-4">
            <p className="text-4xl text-center dark:text-white">About Me </p>

            <div className=" py-12 mx-auto max-w-7xl sm:px-6 md:px-12  lg:py-16">
              <div className="flex flex-wrap items-center mx-auto max-w-7xl">
                <div className="w-full lg:max-w-lg lg:w-1/2 rounded-xl">
                  <div>
                    <div className="relative w-full max-w-lg">
                      <div className="relative">
                        <img
                          className="object-cover object-center mx-auto rounded-lg "
                          alt="hero"
                          src={holl}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full lg:w-1/2 px-4 container">
                  <div className="hero-content">
                    <p className="  font-normal text-lg  dark:text-white text-gray-800  text-justify   lg:mt-2  leading-loose ">
                      I am a software engineer with experience in designing and
                      developing software in both backend and front-end roles. I
                      enjoy solving problems and building things that live on
                      the web. I challenge myself with building beautiful,
                      functional and performant web and mobile applications with
                      different experiences. Here are a few languages and
                      frameworks I’ve been working with recently:
                    </p>

                    <ul className="mt-3 list-disc list-inside">
                      <li className="mt-2 text-yellow-600 dark:text-white">
                        {" "}
                        JavaScript
                      </li>
                      <li className="mt-2 text-blue-600 dark:text-white">
                        React JS
                      </li>
                      <li className="mt-2 text-green-600 dark:text-white">
                        Node JS
                      </li>
                      <li className="mt-2 text-green-200 dark:text-white">
                        Python
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" mt-14 ">
          <div className="container mx-auto px-6 flex flex-col justify-between items-center relative py-4">
            <p className="text-4xl text-center dark:text-white">Works</p>

            <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 md:px-12 lg:px-24 lg:py-24">
              <div className="flex flex-wrap items-center mx-auto max-w-7xl">
                <div className="w-full lg:max-w-lg lg:w-1/2 rounded-xl">
                  <div>
                    <div className="relative w-full max-w-lg">
                      <div className="relative">
                        <img
                          className="object-cover object-center mx-auto rounded-lg shadow-2xl"
                          alt="hero"
                          src={teb}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start mt-12 mb-16 text-left lg:flex-grow lg:w-1/2 lg:pl-6 xl:pl-24 md:mb-0 xl:mt-0">
                  <span className="mb-8 text-3xl font-bold tracking-widest text-blue-600 uppercase dark:text-white ">
                    {" "}
                    TOBI{" "}
                  </span>
                  <div className="relative items-center w-full px-5 py-12 mx-auto md:px-12  max-w-7xl ">
                    <div className="grid grid-cols-1 ">
                      <div className="w-full max-w-lg mx-auto my-4   rounded-xl">
                        <div className="">
                          <span className="mb-8 text-xs font-semibold tracking-widest text-blue-600 dark:text-white  ">
                            A personal blog website
                          </span>
                          <p className="mt-3 text-base leading-relaxed text-gray-500 dark:text-white ">
                            React JS Tailwind
                          </p>
                          <div className="flex gap-2 mt-0 lg:mt-6 max-w-7xl">
                            <div className="mt-3 rounded-lg sm:mt-0">
                              <a
                                href="https://tobiajibola.design/"
                                target="_blank"
                                rel="noreferrer"
                                className="items-center block px-10 py-3.5 text-base font-medium text-center text-blue-600 transition duration-500 ease-in-out transform border-2 border-white shadow-md rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:text-white "
                              >
                                VIEW PROJECT
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 md:px-12 lg:px-24 lg:py-24">
              <div className="flex flex-wrap items-center mx-auto max-w-7xl">
                <div className="w-full lg:max-w-lg lg:w-1/2 rounded-xl">
                  <div>
                    <div className="relative w-full max-w-lg">
                      <div className="relative">
                        <img
                          className="object-cover object-center mx-auto rounded-lg shadow-2xl"
                          alt="hero"
                          src={pra}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start mt-12 mb-16 text-left lg:flex-grow lg:w-1/2 lg:pl-6 xl:pl-24 md:mb-0 xl:mt-0">
                  <span className="mb-8 text-3xl font-bold tracking-widest text-blue-600 uppercase dark:text-white ">
                    {" "}
                    PRAISE{" "}
                  </span>
                  <div className="relative items-center w-full px-5 py-12 mx-auto md:px-12  max-w-7xl ">
                    <div className="grid grid-cols-1 ">
                      <div className="w-full max-w-lg mx-auto my-4   rounded-xl">
                        <div className="">
                          <span className="mb-8 text-xs font-semibold tracking-widest text-blue-600 dark:text-white  ">
                            A personal blog website
                          </span>
                          <p className="mt-3 text-base leading-relaxed text-gray-500 dark:text-white ">
                            React JS Tailwind
                          </p>
                          <div className="flex gap-2 mt-0 lg:mt-6 max-w-7xl">
                            <div className="mt-3 rounded-lg sm:mt-0">
                              <a
                                href="https://praiseayodeji.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="items-center block px-10 py-3.5 text-base font-medium text-center text-blue-600 transition duration-500 ease-in-out transform border-2 border-white shadow-md rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:text-white "
                              >
                                VIEW PROJECT
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 md:px-12 lg:px-24 lg:py-24">
              <div className="flex flex-wrap items-center mx-auto max-w-7xl">
                <div className="w-full lg:max-w-lg lg:w-1/2 rounded-xl">
                  <div>
                    <div className="relative w-full max-w-lg">
                      <div className="relative">
                        <img
                          className="object-cover object-center mx-auto rounded-lg shadow-2xl"
                          alt="hero"
                          src={house}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start mt-12 mb-16 text-left lg:flex-grow lg:w-1/2 lg:pl-6 xl:pl-24 md:mb-0 xl:mt-0">
                  <span className="mb-8 text-3xl font-bold tracking-widest text-blue-600 uppercase dark:text-white ">
                    {" "}
                    HOUSE MARKET APP{" "}
                  </span>
                  <div className="relative items-center w-full px-5 py-12 mx-auto md:px-12  max-w-7xl ">
                    <div className="grid grid-cols-1 ">
                      <div className="w-full max-w-lg mx-auto my-4   rounded-xl">
                        <div className="">
                          <span className="mb-8 text-xs font-semibold tracking-widest text-blue-600 dark:text-white  ">
                            A website for listing, renting and buying house.
                          </span>
                          <p className="mt-3 text-base leading-relaxed text-gray-500 dark:text-white ">
                            React JS Tailwind Firebase
                          </p>
                          <div className="flex gap-2 mt-0 lg:mt-6 max-w-7xl">
                            <div className="mt-3 rounded-lg sm:mt-0">
                              <a
                                href="https://house-marketplace-rust-kappa.vercel.app/"
                                target="_blank"
                                rel="noreferrer"
                                className="items-center block px-10 py-3.5 text-base font-medium text-center text-blue-600 transition duration-500 ease-in-out transform border-2 border-white shadow-md rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:text-white "
                              >
                                VIEW PROJECT
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container mx-auto px-6 flex flex-col justify-between items-center relative py-4 max-w-5xl">
            <p className=" text-center dark:text-white">
              Some things I'm exploring and experimenting with
            </p>

            <div className="relative mx-auto max-w-7xl dark:text-white">
              <div className="grid max-w-lg gap-12 mx-auto mt-10 lg:grid-cols-3 lg:max-w-none">
                <div className="flex flex-col mb-12 overflow-hidden cursor-pointer  ">
                  <div>
                    <div className="flex-shrink-0 border border-spacing-3 p-7 hover:-translate-y-6 mt-10 ">
                      <p className=" text-center">Mentors Landing Page</p>

                      <p className=" text-center mt-10">
                        A frontend mentor challenge built with tailwind css
                      </p>

                      <div className="flex justify-between mt-20 ">
                        <a
                          href="https://github.com/LloydKay"
                          rel="noreferrer"
                          target="_blank"
                          className="mx-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-brand-github"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"></path>
                          </svg>
                        </a>

                        <a
                          href="https://github.com/LloydKay"
                          rel="noreferrer"
                          target="_blank"
                          className="mx-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col mb-12 overflow-hidden cursor-pointer ">
                  <div>
                    <div className="flex-shrink-0 border border-spacing-3 p-7 hover:-translate-y-6 mt-10">
                      <p className=" text-center">Gym website with animate</p>

                      <p className=" text-center mt-10">
                        A gym website built with tailwind css and animate css
                      </p>

                      <div className="flex justify-between mt-20 ">
                        <a
                          href="https://github.com/LloydKay"
                          rel="noreferrer"
                          target="_blank"
                          className="mx-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-brand-github"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"></path>
                          </svg>
                        </a>

                        <a
                          href="https://github.com/LloydKay"
                          rel="noreferrer"
                          target="_blank"
                          className="mx-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" py-20  overflow-hidden relative z-10">
          <div className="container flex mx-auto">
            <div className="flex flex-wrap lg:justify-between ">
              <div className="w-full lg:w-5/12 md:w-5/12  xl:ml-16 sm:items-center ">
                <div className=" mb-12 lg:mb-0">
                  <div className="relative ">
                    <img
                      className="object-cover object-center mx-auto rounded-lg "
                      alt="hero"
                      src={contact}
                    />
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-1/2  px-4 ">
                <p className="text-4xl text-center dark:text-white">
                  Reach out to me
                </p>
                <Animated
                  animationIn="shake"
                  animationOut="fadeOut"
                  isVisible={true}
                >
                  <div className=" relative rounded-lg p-8 sm:p-12 shadow-lg">
                    <div className="md:flex  mt-12 justify-between">
                      <div className="p-3">
                        <button className="p-2   border border-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600  dark:text-white   text-sm font-medium rounded-md">
                          Say Hello
                        </button>
                      </div>
                      <div className="p-3">
                        <button
                          type="button"
                          onClick={() => {
                            window.open(
                              "https://www.buymeacoffee.com/wesleykay0p",
                              "_blank"
                            );
                          }}
                          className="p-2  border border-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 dark:text-white text-sm font-medium rounded-md"
                        >
                          Buy me Coffee
                        </button>
                      </div>

                      <div className="p-3">
                        <button className=" p-2  border border-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 dark:text-white text-sm font-medium rounded-md">
                          Music Recommendation
                        </button>
                      </div>
                    </div>

                    <form onSubmit={onSubmit}>
                      <div className="mb-6 mt-6">
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium dark:text-white"
                        >
                          {" "}
                          Name{" "}
                        </label>

                        <input
                          id="name"
                          name="name"
                          type="name"
                          autoComplete="name"
                          onChange={handleStateChange}
                          required
                          className=" w-full px-5 py-3 text-base transition bg-transparent duration-500 ease-in-out transform dark:border-white border border-black rounded-lg text-neutral-600  focus:outline-none focus:border-transparent focus:ring-2 dark:focus:ring-black focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-300"
                          value={mailerState.name}
                        />
                      </div>
                      <div className="mb-6">
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium dark:text-white"
                        >
                          {" "}
                          Email address{" "}
                        </label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          autoComplete="email"
                          onChange={handleStateChange}
                          required
                          className="block w-full px-5 py-3 text-base transition bg-transparent duration-500 ease-in-out transform dark:border-white border border-black rounded-lg text-neutral-600  focus:outline-none focus:border-transparent focus:ring-2 dark:focus:ring-black focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-300"
                          value={mailerState.email}
                        />
                      </div>

                      <div className="mb-6">
                        <label className="block text-sm font-medium dark:text-white">
                          {" "}
                          Message{" "}
                        </label>

                        <textarea
                          onChange={handleStateChange}
                          name="message"
                          className="block w-full px-5 py-3 text-base transition bg-transparent duration-500 ease-in-out transform dark:border-white border border-black rounded-lg text-neutral-600  focus:outline-none focus:border-transparent focus:ring-2 dark:focus:ring-black focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-300"
                          value={mailerState.message}
                          rows="6"
                          required
                        ></textarea>
                      </div>
                      <div>
                        {!loading ? (
                          <button
                            type="submit"
                            className="
                       
                        w-full
                        dark:text-white
                        bg-primary
                        rounded
                       
                        p-3
                        transition
                        hover:bg-opacity-90
                        dark:border-white border border-black
                        "
                          >
                            Send Message
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="w-full
                        dark:text-white
                        bg-primary
                        rounded
                       flex justify-center items-center
                        p-3
                        transition
                        hover:bg-opacity-90
                        dark:border-white border border-black"
                            disabled
                          >
                            <svg
                              width="5"
                              height="5"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="animate-spin h-5 w-5 mr-3 ...  dark:text-white"
                              strokeWidth={1.5}
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"
                              />
                            </svg>
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </Animated>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
